import { RootState } from '../reducers'

export const cartographyBeaconSelector = (state: RootState, id: string) => (state.cartographyBeacons && state.cartographyBeacons[id] ? state.cartographyBeacons[id] : null)
